import React from 'react';
import Paginations from '../../common/paginations';
import moment from 'moment';
import constant from '../../../constant';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const ACCEPTED_REPORT_RECEIVED_COUNT_KEY = 'Accepted, Report received_count';
const ACCEPTED_REPORT_RECIEVED_COUNT_KEY = 'Accepted, Report recieved_count';

const getAcceptedStatusCount = (item) => {
    if (item?.[ACCEPTED_REPORT_RECEIVED_COUNT_KEY] !== undefined) {
        return item[ACCEPTED_REPORT_RECEIVED_COUNT_KEY];
    }
    if (item?.[ACCEPTED_REPORT_RECIEVED_COUNT_KEY] !== undefined) {
        return item[ACCEPTED_REPORT_RECIEVED_COUNT_KEY];
    }
    return item?.Accepted_count || 0;
};

const Index = ({ data, limit, handlePageChange }) => {
    const { page, total, projects, groups } = data;

    const renderTableHeader = () => (
        <thead>
            <tr>
                <th className="w500">Project</th>
                <th>Unscheduled</th>
                <th className="w150">Scheduled</th>
                <th className="w150">AQ</th>
                <th className="w150">AA</th>
                <th className="w150">NA</th>
                <th className="w150">Total</th>
            </tr>
        </thead>
    );

    const renderRow = (item) => (
        <tr key={item.PROJECT_ID} >
            <td>
                <p className="s1">
                    <Link to={{
                        pathname: constant.Authedcomponent.fatProject.url,
                        state: {
                            projectId: item.PROJECT_ID,
                            projectName: item.PROJECT_NAME
                        }
                    }}>{item.PROJECT_CODE} - {item.PROJECT_NAME}</Link>
                </p>
            </td>
            <td>
                <p className="s1">{item.Unscheduled_count}</p>
            </td>
            <td>
                <p className="s1">{item.Scheduled_count}</p>
            </td>
            <td>
                <p className="s1">{item['Accepted with Comments_count']}</p>
            </td>
            <td>
                <p className="s1">{getAcceptedStatusCount(item)}</p>
            </td>
            <td>
                <p className="s1">{item['Not Applicable_count']}</p>
            </td>
            <td>
                <p className="s1">{item.total_fat}</p>
            </td>
        </tr>
    );

    return (
        <React.Fragment>
            <table className="plan-approval-table">
                {renderTableHeader()}
                <tbody>
                    {groups
                        ? Object.entries(groups).map(([groupName, groupProjects]) => (
                            <React.Fragment key={groupName}>
                                <div className="company-name-hul">
                                    <h4>{groupName}</h4>
                                </div>
                                {groupProjects.map(renderRow)}
                            </React.Fragment>
                        ))
                        : projects?.length > 0
                            ? projects.map(renderRow)
                            : (
                                <tr>
                                    <td colSpan="4" className="text-center">No Record Found</td>
                                </tr>
                            )}
                </tbody>
            </table>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={handlePageChange}
            />
        </React.Fragment>
    );
};

export default Index;
